import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Slider } from "@/components/ui/slider";
import { fmtCcy, fmtUSDStrict } from "@/lib/format";

export const QuantityField = ({ symbol, contract, qty, setQty, minQty, belowMin }) => (
  <div className="space-y-2">
    <div className="flex items-center justify-between">
      <Label>{contract ? `Quantity (${contract.lot_unit})` : "Quantity (fractional)"}</Label>
      <span className="numeric text-sm font-medium">{qty}</span>
    </div>
    <Slider min={minQty} max={contract ? Math.max(contract.lot_size, minQty * 20) : 100}
      step={minQty} value={[qty]} onValueChange={(v) => setQty(v[0])}
      data-testid="order-ticket-quantity-slider" />
    <Input type="number" value={qty} min={minQty} step={minQty}
      onChange={(e) => setQty(Number(e.target.value))} data-testid="order-ticket-quantity-input" />
    {belowMin && (
      <p className="text-xs font-medium text-destructive" data-testid="order-ticket-min-error">
        The minimum order for {symbol} is {minQty} {contract ? contract.lot_unit : "units"}.
      </p>
    )}
  </div>
);

export const CostSummary = ({ currency, estLocal, estUsd, fee }) => (
  <div className="rounded-lg bg-secondary p-3 text-sm space-y-1">
    <div className="flex justify-between">
      <span className="text-muted-foreground">Est. cost</span>
      <span className="numeric">{fmtCcy(estLocal, currency)}</span>
    </div>
    {currency !== "USD" && (
      <div className="flex justify-between">
        <span className="text-muted-foreground">Est. cost (USD)</span>
        <span className="numeric">{fmtUSDStrict(estUsd)}</span>
      </div>
    )}
    <div className="flex justify-between">
      <span className="text-muted-foreground">Fee (0.1%)</span>
      <span className="numeric">{fmtUSDStrict(fee)}</span>
    </div>
  </div>
);
